var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(helpers,"eq").call(alias1,lookupProperty(depth0,"icon"),"custom",{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":2,"column":7},"end":{"line":2,"column":25}}}),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":13,"column":9}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"icon_url"),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":0},"end":{"line":8,"column":9}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression;

  return "<span class=\"topic-appearance-icon\" aria-hidden=\"true\">\n<img class=\"topic-appearance-image topic-icon-light\" src=\""
    + alias3(alias2(alias1(depth0, "icon_url", {"start":{"line":5,"column":60},"end":{"line":5,"column":68}} ), depth0))
    + "?theme=light\" width=\"16\" height=\"16\" alt=\"\" />\n<img class=\"topic-appearance-image topic-icon-dark\" src=\""
    + alias3(alias2(alias1(depth0, "icon_url", {"start":{"line":6,"column":59},"end":{"line":6,"column":67}} ), depth0))
    + "?theme=dark\" width=\"16\" height=\"16\" alt=\"\" />\n</span>";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(helpers,"eq").call(alias1,lookupProperty(depth0,"icon"),"emoji",{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":9,"column":11},"end":{"line":9,"column":28}}}),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":9,"column":0},"end":{"line":13,"column":0}}})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span class=\"topic-appearance-icon\" aria-hidden=\"true\">"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,lookupProperty(helpers,"topic_emoji").call(alias1,depth0,{"name":"topic_emoji","hash":{},"data":data,"loc":{"start":{"line":10,"column":63},"end":{"line":10,"column":78}}}),{"name":"with","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":55},"end":{"line":10,"column":109}}})) != null ? stack1 : "")
    + "</span>";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(require("./status_emoji.hbs"),depth0,{"name":"status_emoji","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<i class=\"zulip-icon zulip-icon-"
    + alias1(container.lambda(container.strict(depth0, "icon", {"start":{"line":12,"column":34},"end":{"line":12,"column":38}} ), depth0))
    + " topic-appearance-icon\" style=\""
    + alias1(lookupProperty(helpers,"topic_icon_style").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"topic_icon_style","hash":{},"data":data,"loc":{"start":{"line":12,"column":71},"end":{"line":12,"column":93}}}))
    + "\" aria-hidden=\"true\"></i>";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"icon"),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":14,"column":9}}})) != null ? stack1 : "");
},"usePartial":true,"useData":true});